import React from "react";
import { Plus } from "lucide-react";

export interface AddStakeholderButtonProps {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
}

const AddStakeholderButton: React.FC<AddStakeholderButtonProps> = ({
  label,
  onClick,
  disabled
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="
        flex
        h-9
        shrink-0
        items-center
        justify-center
        gap-2
        rounded-[8px]
        p-2
        text-[14px]
        font-normal
        leading-[20px]
        text-[#737373]
        disabled:cursor-not-allowed
        disabled:opacity-50
      "
    >
      <Plus
        size={16}
        strokeWidth={2}
        className="shrink-0 text-[#737373]"
      />

      <span className="truncate">
        {label}
      </span>
    </button>
  );
};

export default AddStakeholderButton;



interface AddButtonProps {
  onClick: () => void;
  label?: string;
  className?: string;
}

export const AddButton: React.FC<AddButtonProps> = ({
  onClick,
  label = "Add",
  className = "",
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        flex
        h-9
        shrink-0
        items-center
        justify-center
        gap-2
        rounded-[8px]
        bg-[#F5F5F5]
        px-4
        py-2
        text-[14px]
        font-medium
        leading-[20px]
        text-[#171717]
        font-[Inter]
        shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]
        ${className}
      `}
    >
      <Plus
        size={16}
        strokeWidth={2}
        className="shrink-0"
      />

      <span>{label}</span>
    </button>
  );
};
